// extracted by mini-css-extract-plugin
export default {"parent":"Footer_parent__GPmgN","container":"Footer_container__c0Q1z","icons":"Footer_icons__JfHkL"};